module.exports = __webpack_public_path__ + "img/nexultra-L-brush.ee9ca68a.jpg";